import ModalTitle from './ModalTitle';
import Modal from './Modal';

export default Object.assign(Modal, {
  Title: ModalTitle,
});
